module.exports = __webpack_public_path__ + "static/the-talent-behind-disney-communications-index-69f15342c327927b6dea6150db20d3a6.jpg";